import { Box, Modal } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { setUserDetails } from "../../../redux/cookiesReducer";

const AgencySideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showLogout, setShowLogout] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { title: "Dashboard", icon: "📈", path: "/DashboradScreen" },
    { title: "Providers", icon: "👨‍⚕️", path: "/ProvidersScreen" },
    { title: "Patients", icon: "🧑‍🤝‍🧑", path: "/Patientsagency" },
    { title: "Appointments", icon: "📅", path: "/Appointmentclinic" },
    { title: "Financial", icon: "💰", path: "/FinancialagaencyScreen" },
    { title: "Messages", icon: "💬", path: "/Message" },
    { title: "Reports", icon: "📊", path: "/AgencyReports" },
    { title: "My Profile", icon: "👤", path: "/MyProfileAgency" },
    { title: "Settings", icon: "⚙️", path: "/Settingss" },
    { title: "Help & Support", icon: "🆘", path: "/SupportHelp" },
  ];

  const handleLogoutYes = () => {
    dispatch(setUserDetails(null));
    navigate("/");
  };

  return (
    <>
      <button className="mobile-menu-icon" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </button>

      <div
        className={`overlay ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(false)}
      ></div>

      <div className={`sidebar-wrapper ${isOpen ? "open" : ""}`}>
        <div className="logo_sidebar">
          <div className="logo-icon">
            <i className="fas fa-stethoscope" />
          </div>
          <p>
            <strong>EnnVital</strong>
            <br />
            <small>
              Empowering Health
              <br />
              Connecting Care
            </small>
          </p>
        </div>

        <div className="divider_sidebar" />

        <nav className="menu-list">
          {menuItems.map((item, index) => {
            const isActive = location.pathname === item.path;
            return (
              <div
                key={index}
                className={`menu-item ${isActive ? "active" : ""}`}
                onClick={() => {
                  navigate(item.path);
                  setIsOpen(false); // close sidebar on mobile
                }}
              >
                <span className="menu-icon">{item.icon}</span>
                <span className="menu-title">{item.title}</span>
              </div>
            );
          })}

          <div
            className="menu-item logout"
            onClick={() => {
              setShowLogout(true);
              setIsOpen(false);
            }}
          >
            <span className="menu-icon">🚪</span>
            <span className="menu-title">Log Out</span>
          </div>
        </nav>

        <Modal
          open={showLogout}
          onClose={() => setShowLogout(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box sx={modalStyle}>
            <div className="logout-modal">
              <div className="logout_txt">Logout</div>
              <div
                className="logout_sure"
                style={{ marginBottom: 20, marginTop: 10 }}
              >
                Are you sure to logout your account?
              </div>
              <div className="logout-buttons">
                <button
                  className="cancel-button"
                  onClick={() => setShowLogout(false)}
                >
                  No
                </button>
                <button className="confirm-button" onClick={handleLogoutYes}>
                  Yes
                </button>
              </div>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default AgencySideBar;

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
};
